import { useEffect } from "react";

/**
 * Direct port of the legacy online/offline handling: on 'offline', do
 * nothing (video keeps playing from buffer/SW cache). On 'online', wait 2s
 * for DNS to actually stabilise (fetching immediately after the OS reports
 * "online" often still gives ERR_NAME_NOT_RESOLVED), then re-verify and run
 * the recovery callback. This is what makes reconnection feel seamless
 * instead of racing a dead network.
 */
export function useConnectivity(onReconnect: () => void) {
  useEffect(() => {
    function handleOffline() {
      console.log("Network offline - video will continue from buffer/SW cache");
    }

    function handleOnline() {
      console.log("Network detected online - waiting 2s for DNS to stabilise");
      setTimeout(() => {
        if (!navigator.onLine) return; // dropped again within the window
        console.log("Network stable - running post-reconnect recovery");
        onReconnect();
      }, 2000);
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [onReconnect]);
}
